import { observer } from 'mobx-react';
import onboardingNavigationStore from '../../stores/onboarding-navigation-store';
import './onboarding-navigation.scss';


const Item: React.FC<{isCurrent: boolean}> = ({ isCurrent }) => {
    return (
        <div className={`nav-item${isCurrent ? ' current' : ''}`}></div>
    );
};

const OnboardingNavigation: React.FC = observer(() => {
    
    const navProps = onboardingNavigationStore.getNavigationComponentProps();
    
    return (
        <div className={`onboarding-navigation-placement${navProps.is_hidden ? ' hidden' : ''}`}>
            <div className="onboarding-navigation">
                {navProps.list.map((isCurrent, i) => <Item key={i} isCurrent={isCurrent} />)}
            </div>
        </div>
    );
});

export default OnboardingNavigation;
